export const GET_CHARACTER_FAVORITE = 'GET_CHARACTER_FAVORITE';
export const GET_CHARACTER_FAVORITE_SUCCESS = 'GET_CHARACTER_FAVORITE_SUCCESS';
export const GET_CHARACTER_REQUEST = 'GET_CHARACTER_REQUEST';
export const GET_CHARACTER_SUCCESS = 'GET_CHARACTER_SUCCESS';
export const GET_CHARACTER_DETAIL_REQUEST = 'GET_CHARACTER_DETAIL_REQUEST';
export const GET_CHARACTER_DETAIL_SUCCESS = 'GET_CHARACTER_DETAIL_SUCCESS';
export const RESET_CHARACTER = 'RESET_CHARACTER';